import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/runner/work/handbook/handbook/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "overview"
    }}>{`Overview`}</h1>
    <p>{`This is my (personal) handbook. Welcome.`}</p>
    <p>{`I say "personal" though many of the resources here relate to my profession / career. I describe it as "personal" because, although I would consider others finding it useful a `}<em parentName="p">{`serious`}</em>{` win, it's a repository of resources and notes intended for myself.`}</p>
    <p>{`What I guess I'm trying to say is that no part of this is meant to be exhaustive or even sensical as a guide for any of the topics it touches on.`}</p>
    <p>{`That said, feel free to look around, and suggestions / feedback can be logged on the `}<a parentName="p" {...{
        "href": "https://github.com/rosskuyper/handbook"
      }}>{`github repo`}</a>{`.`}</p>
    <p>{`Most sections are still pretty empty, so a good starting place might be one of:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/leadership/getting-to-know-a-team"
        }}>{`Getting to know a team`}</a>{`.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "leadership/lessons-from-silicon-valley-leadership"
        }}>{`Lessons from Silicon Valley Leadership`}</a>{`.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      